module.exports = __webpack_public_path__ + "static/TakahideNakamura-6cec6c8b2f637c796a8edabf597bcd64.png";